import * as types from './mutation-types'

export const setMessage = ({ commit }, message) => {
  console.log(types.SET_SUMMARY_MESSAGE)
  if (message === {}) { return }
  commit(types.SET_SUMMARY_MESSAGE, { message: message, hasExpand: true })
}

export const clearMessage = ({ commit }) => {
  console.log(types.SET_SUMMARY_MESSAGE)
  commit(types.SET_SUMMARY_MESSAGE, { message: {}, hasExpand: false })
}

export const toggleSummaryMessage = ({ commit }) => {
  console.log(types.TOGGLE_SUMMARY_MESSAGE)
  commit(types.TOGGLE_SUMMARY_MESSAGE)
}

export const setViewTitle = ({ commit }, title) => {
  console.log(types.SET_VIEW_TITLE, title)
  commit(types.SET_VIEW_TITLE, title)
}

export const setCurrentKinoId = ({ commit }, { id }) => {
  console.log(types.SET_CURRENT_KINO_ID, id)
  commit(types.SET_CURRENT_KINO_ID, id)
}

export const setNotificationCount = ({ commit }, count) => {
  console.log('SET_NOTIFICATION_COUNT', types.SET_NOTIFICATION_COUNT, count)
  commit(types.SET_NOTIFICATION_COUNT, count)
}

export const setAdminNotificationCount = ({ commit }, count) => {
  console.log('SET_ADMIN_NOTIFICATION_COUNT', types.SET_ADMIN_NOTIFICATION_COUNT, count)
  commit(types.SET_ADMIN_NOTIFICATION_COUNT, count)
}

export const setSystemNotificationCount = ({ commit }, count) => {
  console.log('SET_SYSTEM_NOTIFICATION_COUNT', types.SET_SYSTEM_NOTIFICATION_COUNT, count)
  commit(types.SET_SYSTEM_NOTIFICATION_COUNT, count)
}

export const setCarNotificationCount = ({ commit }, count) => {
  console.log('SET_CAR_NOTIFICATION_COUNT', types.SET_CAR_NOTIFICATION_COUNT, count)
  commit(types.SET_CAR_NOTIFICATION_COUNT, count)
}

export const setLicenceNotificationCount = ({ commit }, count) => {
  console.log('SET_LICENCE_NOTIFICATION_COUNT', types.SET_LICENCE_NOTIFICATION_COUNT, count)
  commit(types.SET_LICENCE_NOTIFICATION_COUNT, count)
}
